<template>
  <Layout>
  <DsIslandsContainer>
    <DsIsland align-center>
      <div class="flex justify-center mb-spacing-600">
        <DsIllustration name="status-service-error" type="narrow" />
      </div>
      <div class="body-500 text-center px-spacing-600" v-html="translate('unavailable:title', startTime)"></div>
        <DsButton class="mx-auto mt-spacing-600" size="medium" @click="goHome">
          <div class="label-600-soft">
            {{ 'unavailable:btn' | translate }}
          </div>
        </DsButton>
    </DsIsland>
  </DsIslandsContainer>
  </Layout>
</template>

<script setup>
import { eventBus } from 'kaspi.frontend/src/modules/eventBus/eventBus'
import { sendAnalyticEvent } from '@/helpers/sendAnalyticEvent'
import { onMounted, ref } from 'vue';
import { DsIsland, DsIslandsContainer, DsIllustration, DsButton } from '@ds/vue2';
import Layout from '@/components/ui/Layout/Layout.vue'

const startTime = ref('7')

onMounted(async () => {
  await this.dataStep()

  eventBus.$emit('kaspiLoading', false)
  sendAnalyticEvent('online_child_gold_close_time', {
    started_from: [this.$store.getters['app/urlParams'].startedFrom],
    stage: ['start'],
    page_path: ['/bank/bpm/products/goldkids/goldkid'],
    external_message_id: [this.$store.getters['goldkidProcess/pId']]
  })
})
const goHome = () => {
  window.location.href = process.env.VUE_APP_BASE_URL
}
</script>

